import * as env from 'src/lib/env';
import { captureException } from 'src/lib/sentry';

const SDK_SCRIPT_ID = 'facebook-jssdk';
const APP_ID = env.getFacebookAppID();

export const injectFacebookSDK = (page: string): void => {
  // Mock Facebook SDK, only in 'test' environment
  try {
    if (env.getAppEnv() === 'test') {
      import('./sdkMock');
      return;
    }

    if (document.getElementById(SDK_SCRIPT_ID)) {
      return;
    }

    window.fbAsyncInit = () => {
      window.FB.init({
        appId: APP_ID,
        cookie: true,
        status: true,
        version: 'v8.0',
      });
    };

    const js = document.createElement('script');
    js.id = SDK_SCRIPT_ID;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(js, firstScript);
    } else {
      document.body.appendChild(js);
    }
  } catch (error) {
    captureException(error as Error, {
      extra: {
        source: `${page} -> injectFacebookSDK`,
      },
    });
  }
};

export * from './facebook';
